import { render } from "./PageBackButton.vue?vue&type=template&id=e0b95d14&scoped=true&ts=true&lang=pug"
import script from "./PageBackButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageBackButton.vue?vue&type=script&lang=ts&setup=true"

import "./PageBackButton.vue?vue&type=style&index=0&id=e0b95d14&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b95d14"]])

export default __exports__